import RestClient from './RestClient'
import moment = require('moment')

export interface IRequestTipInfo {
  steamId: string
  amount: number
  bank: string
}

export interface IRequestTipResult {
  tipId: number
  depId: number
}

export interface IDepRequestResult {
  id: number,
  amount: number,
  status: TipRequestStatus,
  bank: TipBankInfo,
  comment?: string,
  actualAmount: number,
  createdAt: moment.Moment
}

export interface ITipRequestResult {
  id: number,
  steamId: string,
  amount: number,
  status: TipRequestStatus,
  comment?: string,
  createdAt: moment.Moment
}

const ENTRY_POINT = 'home'

export default class TipService {
  restClient: RestClient

  constructor() {
    this.restClient = new RestClient({
      baseURL: 'https://csgoempire.vn/api'
    })
  }

  getTipHomeInfo(): Promise<TipHomeInfo> {
    return this.restClient.get(ENTRY_POINT + '/info')
  }

  requestTip(requestTipInfo: IRequestTipInfo): Promise<IRequestTipResult> {
    return this.restClient.post(ENTRY_POINT + '/request-tip', requestTipInfo)
  }

  getTipRequestInfo(tipId: number): Promise<ITipRequestResult> {
    return this.restClient.get(ENTRY_POINT + '/tip-info', {tipId: tipId})
  }

  getDepRequestInfo(depId: number): Promise<IDepRequestResult> {
    return this.restClient.get(ENTRY_POINT + '/dep-info', {depId: depId})
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/TipService.ts